
function setActiveFilters() {
  setTimeout(function () {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    let new_filter_string = '';
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      if (hash[0] == 'pf_opt_size') {
        if ($("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").length) {
          new_filter_string += '<a href="javascript:void(0);" data-id="' + hash[0] + '" data-label="' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '" data-value="' + hash[1] + '">' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '<span class="icon-close"></span></a>';
        }
      }
      else if (hash[0] == 'pf_t_category') {
        if ($("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").length) {
          new_filter_string += '<a href="javascript:void(0);" data-id="' + hash[0] + '" data-label="' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '" data-value="' + hash[1] + '">' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '<span class="icon-close"></span></a>';
        }
      }
      else if (hash[0] == 'pf_t_trimester') {
        if ($("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").length) {
          new_filter_string += '<a href="javascript:void(0);" data-id="' + hash[0] + '" data-label="' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '" data-value="' + hash[1] + '">' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '<span class="icon-close"></span></a>';
        }
      }
      else if (hash[0] == 'pf_t_color') {
        if ($("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").length) {
          new_filter_string += '<a href="javascript:void(0);" data-id="' + hash[0] + '" data-label="' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '" data-value="' + hash[1] + '">' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '<span class="icon-close"></span></a>';
        }
      }
      else {
        if ($("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").length) {
          new_filter_string += '<a href="javascript:void(0);" data-id="' + hash[0] + '" data-label="' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '" data-value="' + hash[1] + '">' + $("#bc-sf-filter-options-wrapper a.selected[data-id='" + hash[0] + "'][data-value='" + hash[1] + "']").attr('data-title') + '<span class="icon-close"></span></a>';
        }
      }
    }
    $("#active-filters").html(new_filter_string);
  }, 500);
}

setTimeout(function () {
  setActiveFilters();
  $(".bc-sf-filter-block-title h3 span").addClass('up');
  $(".bc-sf-filter-block-content").hide();
  $(".filter__container__filter-wrapper").after('<div class="apply-filters-wrapper"><button class="button apply-filters">Apply Filters</button></div>');
}, 500);

$("body").on('click', '#active-filters a', function () {
  let filter_label = $(this).attr('data-label');
  let filter_value = $(this).attr('data-value');
  let filter_cat = $(this).attr('data-id');
  $("#bc-sf-filter-options-wrapper a.selected[data-id='" + filter_cat + "'][data-value='" + filter_value + "']").click();
  $(this).fadeOut(250, function () {
    $(this).remove();
  });
});

$("body").on('click', 'a.bc-sf-filter-option-item', function () {
  setActiveFilters();
});

$("body").on('click', 'button.btn-clear-filter', function () {
  $("#shopify-section-collection-filtered .btn-close-filter").click();
  $("#active-filters a").remove();
  $(".bc-sf-filter-block-content").hide();
});

$("body").on('click', '#shopify-section-collection-filtered .apply-filters', function () {
  $("#shopify-section-collection-filtered .filter .filter__action-bar .btn-open-filter").click();
});

$("body").on('click', '#shopify-section-collection-filtered .filter-close', function () {
  $("#shopify-section-collection-filtered .apply-filters").click();
});